'use client';

import React, { FC, useMemo } from 'react';
import { useAuthContext } from '@/src/v2/layout/Auth/context/AuthContext';
import { signOutServiceV2 } from '@/src/services/auth';
import dynamic from 'next/dynamic';
import LoginSignup from './LoginSignup/LoginSignup';

const AuthModal = dynamic(() => import('@/src/v2/layout/Auth/AuthModal'), {
  ssr: false,
});
const LoginModal = dynamic(
  () => import('@/src/v2/layout/Auth/LoginModal/LoginModal'),
  { ssr: false }
);
const SignUpModal = dynamic(
  () => import('@/src/v2/layout/Auth/SignUpModal/SignUpModal'),
  { ssr: false }
);
const VerifyEmailModal = dynamic(
  () => import('@/src/v2/layout/Auth/VerifyEmailModal/VerifyEmailModal'),
  { ssr: false }
);
const ForgotPassword = dynamic(
  () => import('@/src/v2/layout/Auth/FogotPassword/FogotPassword'),
  { ssr: false }
);
const NewPasswordModal = dynamic(
  () => import('@/src/v2/layout/Auth/NewPassword/NewPassword'),
  { ssr: false }
);
const NewPasswordResponseModal = dynamic(
  () => import('@/src/v2/layout/Auth/NewPasswordResponse/NewPasswordResponse'),
  { ssr: false }
);
const AddCountryModal = dynamic(
  () => import('@/src/v2/layout/Auth/AddCountryModal/AddCountryModal'),
  { ssr: false }
);
const TwitterModal = dynamic(() => import('./LoginModal/TwitterModal'), {
  ssr: false,
});
const SocialSignupModal = dynamic(
  () => import('./SocialSignupModal/SocialSignup'),
  {
    ssr: false,
  }
);
const SocialProfileModal = dynamic(
  () => import('./SocialProfileModal/SocialProfileModal'),
  {
    ssr: false,
  }
);

const Auth: FC = () => {
  const { mode, setMode } = useAuthContext();
  const content = useMemo(() => {
    switch (mode) {
      case 'sign in':
        signOutServiceV2();
        // return <LoginModal onClose={() => setMode(undefined)} />;
        return <LoginSignup onClose={() => setMode(undefined)} />;
      case 'sign up':
        return <SignUpModal onClose={() => setMode(undefined)} />;
      case 'verify':
        return <VerifyEmailModal onClose={() => setMode(undefined)} />;
      case 'forgot password':
        return <ForgotPassword onClose={() => setMode(undefined)} />;
      case 'verify forgot password':
        return <VerifyEmailModal onClose={() => setMode(undefined)} />;
      case 'set new password':
        return <NewPasswordModal onClose={() => setMode(undefined)} />;
      case 'wrong code':
      case 'password changed':
        return <NewPasswordResponseModal onClose={() => setMode(undefined)} />;
      case 'add country':
        return <AddCountryModal onClose={() => setMode(undefined)} />;
      case 'twitter':
        return <TwitterModal onClose={() => setMode(undefined)} />;
      case 'socialSignup':
        return <SocialSignupModal onClose={() => setMode(undefined)} />;
      case 'social-profile':
        return <SocialProfileModal onClose={() => setMode(undefined)} />;
      default:
        return <></>;
    }
  }, [mode]);

  const title = useMemo(() => {
    switch (mode) {
      case 'sign up':
      case 'verify':
      case 'add country':
        return '';
      case 'sign in':
        return 'Log in';
      case 'forgot password':
      case 'verify forgot password':
        return 'Forgot Password';
      case 'set new password':
        return 'Create new password';
      case 'wrong code':
        return 'Try again';
      case 'password changed':
        return 'Success';
      case 'twitter':
        return 'Complete Signup';
      case 'socialSignup':
        return 'Complete Signup';
      case 'social-profile':
        return 'Social Profile';
      default: {
        return '';
      }
    }
  }, [mode]);

  return (
    <AuthModal isOpen={!!mode} title={title} onClose={() => setMode(undefined)}>
      {content}
    </AuthModal>
  );
};

export default Auth;
